import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import CurrentTour from '@app/components/Landing/CurrentTour'
import Motivation from '@app/components/Landing/Motivation'
import Info from '@app/components/Landing/Info'
import About from '@app/components/Landing/About'
import Footer from '@app/components/Landing/Footer'
import Rewards from "@app/components/Landing/Rewards";

const Home = ({ global }) => {
  return (
    <Fragment>
      <CurrentTour event={global.event} />
      <Rewards />
      <Motivation />
      <Info global={global} />
      <About />
      <Footer />
    </Fragment>
  )
}

Home.propTypes = {
  global: PropTypes.object.isRequired
}

export default Home
